import { CMSService } from '../Services/cms.service';
import { BeneficiaryService } from '../Services/beneficiary.service';
import { CmsFooterSitemapProperties } from '../Models/CmsFooterContactsProperties';
import { CmsFooterSocialProperties } from '../Models/CmsFooterContactsProperties';
import { CmsLoginHeaderProperties, CmsLogoProperties } from '../Models/CmsLoginHeaderProperties';
import { GetAllCmsLoginProperties } from '../Models/CmsLoginHeaderProperties';
import { CmsLoginDealsProperties, GroupTicketShowRightCMS } from '../Models/CmsLoginDealsProperties';
import { CmsLoginMainContentProperties } from '../Models/CmsLoginMainContentProperties';
import { CmsAboutUsLandingProperties } from '../Models/CmsAboutUsProperties';
import { CmsAboutUsServicesProperties } from '../Models/CmsAboutUsProperties';
import { CmsAboutUsTimelineProperties } from '../Models/CmsAboutUsProperties';
import { CmsContactUsProperties, NewsAlertProperties, NotificationProperties } from '../Models/CmsContactUsProperties';
import { BeneficiaryAccountAllocationProperties, BeneficiaryAccountProperties } from '../Models/BeneficiaryAccountProperties';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { Route, Router } from '@angular/router';
import { CmsSubHeaderComponent } from '../cms-sub-header/cms-sub-header.component';
import { NgbModal, ModalDismissReasons, NgbModalOptions, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
//import { NewsAlertProperties, NotificationProperties } from '../Models/NewsAndNotificationProperties';
import { Subscription, timer } from 'rxjs';
import { CmsFooterContactsProperties, PrivacyPolicyProperties, TermsOfUseProperties } from '../Models/CmsFooterContactsProperties';
import { catchError, retry, map } from 'rxjs/operators';
import * as $ from 'jquery';
import { InsuranceTypesSwitchProps } from '../Models/TravelInsuranceProperties';
@Component({
  selector: 'app-cms',
  templateUrl: './cms.component.html',
  styleUrls: ['./cms.component.css']
})
export class CMSComponent {
  public progress: number;
  public message: string;

  constructor(private userService: CMSService, private router: Router,
    private modalServiceEmail: NgbModal, private modalService: NgbModal, private modelServiceNoti: NgbModal) { }
    groupTicketShowRightCMS =new GroupTicketShowRightCMS();
    ChangeGroupTicket=():void=>{
      this.userService.ChangeGroupTicketStatus(this.groupTicketShowRightCMS).subscribe(data=>{
      })
    }

  allData$: GetAllCmsLoginProperties;
  navigation: CmsLoginHeaderProperties[] = [];
  loginLanding: CmsLoginMainContentProperties[] = [];
  deals: CmsLoginDealsProperties[] = [];
  footerContacts: CmsFooterContactsProperties[] = [];
  footerSitemap: CmsFooterSitemapProperties[] = [];
  footerSocial: CmsFooterSocialProperties[] = [];
  //logo: CmsLogoProperties[] = [];
  contactUs: CmsContactUsProperties[] = [];
  aboutuslandingData: CmsAboutUsLandingProperties[] = [];
  servicesData: CmsAboutUsServicesProperties[] = [];
  timelineData: CmsAboutUsTimelineProperties[] = [];

  newsObj = new NewsAlertProperties();
  newsUpdateObj = new NewsAlertProperties();
  newsList: NewsAlertProperties[] = [];
  notiObj = new NotificationProperties();
  recievedNotiObj = new NotificationProperties();
  notificationAll: NotificationProperties[] = [];
  notiUpdateObj = new NotificationProperties();
  newsResponse: boolean;
  privacyGetObj = new PrivacyPolicyProperties();
  privacyUpdateObj = new PrivacyPolicyProperties();
  termsGetObj = new TermsOfUseProperties();
  termsUpdateObj = new TermsOfUseProperties();

  closeResult = '';
  modalOptions: NgbModalOptions;
  //modalServiceEmail: any;
  //modalService: any;
  //modelServiceNoti: any;
  public fSocialIcon: any;
  public navLogo: string;
  timerSubscription: any;
  ngOnInit() {
    this.getAgencyID();
    this.getAllData();
    this.getContactData();
    this.getAboutUsLandingData();
    this.getServicesData();
    this.getTimelineData();
    //this.getActiveNews();
    this.userService.getFooterData().subscribe((data) => {


      this.footerContacts = data.footerContacts;


      this.footerSocial = data.footerSocial;

    });
    //this.getActiveNotifications();
    this.timerSubscription = timer(0, 300000).pipe(
      map(() => {
        this.getActiveNews(); // load data contains the http request
        this.getActiveNotifications();
      })
    ).subscribe();
  }

  addNewsPop(content) {
    this.modalServiceEmail.open(content, {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonEmail(reason)}`;
    });
  }

  private getDismissReasonEmail(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  updateNewsPop(content, newsId) {
    this.userService.getNewsById(newsId).subscribe((data) => {
      this.newsUpdateObj = data;
    });

    this.modalService.open(content, {
      backdrop: 'static',
      backdropClass: 'customBackdrop'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  updateNews() {
    try {
      this.userService.updateNews(this.newsUpdateObj).subscribe((data) => {

        if (data == true) {
          let color1 = "#028A0F";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">News Updated Successfully..</font>"
          $("#response-screen").delay(5000).hide(1000);
          this.newsUpdateObj = new NewsAlertProperties();
        }
        else if (data === false) {
          let color2 = "red";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color2 + ">An Error encountered!</font>";
          $("#response-screen").delay(5000).hide(1000);
        }
      })
    }
    catch (e) { }

  }


  addNews() {
    try {
      this.userService.addNews(this.newsObj).subscribe((data) => {
        this.newsResponse = data;
        if (data == true) {
          let color1 = "#028A0F";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">News Added Successfully..</font>"
          $("#response-screen").delay(5000).hide(1000);
          this.newsObj = new NewsAlertProperties();
        }
        else if (data === false) {
          let color2 = "red";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color2 + ">An Error encountered!</font>";
          $("#response-screen").delay(5000).hide(1000);
        }
      })
    } catch (e) {
      //////console.log (e);
    }
  }

  deleteNews(newsId) {
    try {
      this.userService.deleteNews(newsId).subscribe((data) => {
        if (data == true) {
          alert("News Deleted!");
        }
        else {
          alert("Could not Delete news... An Error encountered!");
        }
      })
    } catch (e) {
      //////console.log (e);
    }
  }


  deleteNotification(notiId) {
    this.userService.deleteNotification(notiId).subscribe((data) => {
      if (data == true) {
        alert("Notification Deleted!");
      }
      else {
        alert("Could not Delete notification... An Error encountered!");
      }

    })
  }

  openNotiPop(content, notiId) {

    this.userService.getNotificationById(notiId).subscribe((data) => {
      this.notiUpdateObj = data;
    });

    this.modelServiceNoti.open(content, {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonNoti(reason)}`;
    });

  }

  private getDismissReasonNoti(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  addNotification() {
    this.userService.addNotification(this.notiObj).subscribe((data) => {
      if (data == true) {
        alert("Notification Added!");
        this.notiObj = new NotificationProperties();
      }
      else {
        alert("Could not add notification... An Error encountered!");
      }
    })
  }

  updateNotification() {
    try {
      this.userService.updateNotification(this.notiUpdateObj).subscribe((data) => {
        if (data == true) {
          let color1 = "#028A0F";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Notification Updated Successfully..</font>"
          $("#response-screen").delay(5000).hide(1000);
        }
        else if (data === false) {
          let color2 = "red";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color2 + ">An Error encountered!</font>";
          $("#response-screen").delay(5000).hide(1000);
        }
      })
    } catch (e) { }
  }

  getActiveNews() {
    this.userService.getActiveNews().subscribe((data) => {
      this.newsList = data;
    })
  }

  getActiveNotifications() {
    this.userService.getActiveNotification().subscribe((data) => {
      this.notificationAll = data;
    })
  }

  homeLogo = new CmsLogoProperties();

  logo = '';
  getAllData() {
    try {
      this.userService.getAllLoginPageData().subscribe((data) => {
        this.allData$ = data;
        this.navigation = this.allData$.navigation;
        this.loginLanding = this.allData$.loginLanding;
        this.deals = this.allData$.deals;
        //this.footerContacts = this.allData$.footerContacts;
        //this.footerSitemap = this.allData$.footerSitemap;
        //this.footerSocial = this.allData$.footerSocial;
        this.homeLogo = this.allData$.logo[0];
        this.logo = this.homeLogo.logo;
      });
      this.userService.getFooterData().subscribe((data) => {



        this.footerContacts = data.footerContacts;

        this.footerSocial = data.footerSocial;

      });

      this.userService.GetGroupTicketRight().subscribe(data=>{
        this.groupTicketShowRightCMS=data;
        
      })
      
    }
    catch (e) { }
  }

  //getAgencyID() {
  //  let agencyID = localStorage.getItem('AgencyId');
  //  let userID = Number(localStorage.getItem('UserId'));
  //  if (agencyID == "AG01" && (userID == 1 || userID == 3)) {
  //    this.router.navigateByUrl('/cms');
  //  }
  //  else {
  //    this.router.navigateByUrl('/');
  //  }
  //}

  getLogoID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/app-cms-logo');

    }
    catch (e) {
      //////console.log (e);
    }
  }

  getHeaderID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-header');

    }
    catch (e) {
      //////console.log (e);
    }
  }
  getHeaderDeleted(sr: number) {
    try {
      this.userService.deleteHeader(sr).subscribe((data) => {
        //////console.log (data);
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getLandingID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-landing');

    }
    catch (e) {
      //////console.log (e);
    }
  }

  getDealID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-deals');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getDealDeleted(sr: number) {
    try {
      this.userService.deleteDeals(sr).subscribe((data) => {
        //////console.log (data);
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }


  getContactID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-footer-contacts');
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getSitemapID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-footer-sitemap');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getSitemapDeleted(sr: number) {
    try {
      this.userService.deleteFooterSitemap(sr).subscribe((data) => {
        //this.fSitemapData = data;
        //////console.log (data);
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getSocialID(sr: number) {
    try {
      localStorage.setItem('serialNo', sr.toString())
      this.router.navigateByUrl('/cms-add-footer-social');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getSocialDeleted(sr: number) {
    try {
      this.userService.deleteFooterSocial(sr).subscribe((data) => {
        //////console.log (data);
        this.getAllData();
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getContactData() {
    try {
      this.userService.getContactUs().subscribe((data) => {
        this.contactUs = data;
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getContactUsID(id: number) {
    try {
      localStorage.setItem('contactUsID', id.toString())
      this.router.navigateByUrl('/app-cms-sub-contactus');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getContactUsDeleted(id: number) {
    try {
      this.userService.deleteContactUs(id).subscribe((data) => {
        //////console.log (data);
        this.getContactData();
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getAboutUsLandingData() {
    try {
      this.userService.getAboutUsLanding().subscribe((data) => { this.aboutuslandingData = data; });
    }
    catch (e) { }
  }
  getAboutLandingID(id: number) {
    try {
      localStorage.setItem('aboutUsID', id.toString())
      this.router.navigateByUrl('/app-cms-aboutuslanding');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getAboutLandingDeleted(id: number) {
    try {
      this.userService.deleteAboutUsLanding(id).subscribe((data) => {
        //////console.log (data);
        this.getAboutUsLandingData();
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getServicesData() {
    try {
      this.userService.getAboutUsServices().subscribe((data) => { this.servicesData = data; });
    }
    catch (e) { }
  }
  getServicesID(id: number) {
    try {
      localStorage.setItem('aboutUsServicesID', id.toString())
      this.router.navigateByUrl('/app-cms-aboutusservices');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getServicesDeleted(id: number) {
    try {
      this.userService.deleteAboutUsServices(id).subscribe((data) => {
        //////console.log (data);
        this.getServicesData();
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }

  getTimelineData() {
    try {
      this.userService.getAboutUsTimeline().subscribe((data) => { this.timelineData = data; });
    }
    catch (e) { }
  }
  getTimelineID(id: number) {
    try {
      localStorage.setItem('aboutUsID', id.toString())
      this.router.navigateByUrl('/app-cms-aboutustimeline');
    }
    catch (e) {
      //////console.log (e);
    }
  }
  getTimelineDeleted(id: number) {
    try {
      this.userService.deleteAboutUsTimeline(id).subscribe((data) => {
        //////console.log (data);
      });
    }
    catch (e) {
      //////console.log (e);
    }
  }


  getAgencyID() {
    //let agencyID = localStorage.getItem('AgencyId');
    //let userID = Number(localStorage.getItem('UserId'));

    this.userService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data)
        this.router.navigateByUrl('/cms');

    });
    //if (agencyID == "AG01" && (userID == 1 || userID == 3)) {
    //  this.router.navigateByUrl('/cms');
    //}
    //else {
    //  this.router.navigateByUrl('/');
    //}
  }
  getPrivacyPolicy() {
    try {
      this.userService.getPrivacyPolicy().subscribe((data) => {
        this.privacyGetObj = data;
      });
    } catch (e) {

    }
  }

  privacyModelRef: NgbModalRef;
  openPrivacyPop(content) {
    this.privacyUpdateObj.privacyID = this.privacyGetObj.privacyID;
    this.privacyUpdateObj.privacyStatement = this.privacyGetObj.privacyStatement;
    this.privacyUpdateObj.status = this.privacyGetObj.status;
    //this.userService.getPrivacyPolicy().subscribe((data) => {
    //  this.privacyGetObj = data;
    //});
    this.privacyModelRef = this.modelServiceNoti.open(content, {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    });
    this.privacyModelRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReasonNoti(reason)}`;
    });

  }

  updatePrivacyPolicy() {
    try {
      this.userService.updatePrivacyPolicy(this.privacyUpdateObj).subscribe((data) => {
        if (data == true) {
          let color1 = "#028A0F";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Policy Updated Successfully..</font>"
          $("#response-screen").delay(5000).hide(1000);
          this.getPrivacyPolicy();
          this.privacyModelRef.close();
        }
        else if (data === false) {
          let color2 = "red";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color2 + ">An Error encountered!</font>";
          $("#response-screen").delay(5000).hide(1000);
        }
      })
    } catch (e) { }
  }

  getTermsOfUse() {
    try {
      this.userService.getTermsOfUse().subscribe((data) => {
        this.termsGetObj = data;
      });
    } catch (e) {

    }
  }
  termsModelRef: NgbModalRef;
  updateTermsPop(content) {
    this.termsUpdateObj = this.termsGetObj;
    this.termsModelRef = this.modalService.open(content, {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg'
    });
    this.termsModelRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });

  }

  updateTermsConditions() {
    try {
      this.userService.updateTerms(this.termsUpdateObj).subscribe((data) => {

        if (data == true) {
          let color1 = "#028A0F";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color1 + ">Terms of Use Updated Successfully..</font>"
          $("#response-screen").delay(5000).hide(1000);
          this.getTermsOfUse();
          this.termsModelRef.close();
        }
        else if (data === false) {
          let color2 = "red";
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "<font color=" + color2 + ">An Error encountered!</font>";
          $("#response-screen").delay(5000).hide(1000);
        }
      })
    }
    catch (e) { }
  }

  insuranceOption: string[] = [];
  allOn: boolean = false;
  allOff: boolean = true;
  //insuranceTypes: string[] = ["ZEUS", "UIC"];
  //insuranceTypes = [
  //  { label: 'ZEUS Insurance', value: 'ZEUS', checked: false },
  //  { label: 'United Insurance', value: 'UIC', checked: false },
  //];
  selectedInsuranceOptionsUpdate: InsuranceTypesSwitchProps[] = [];
  toggleAll(state: boolean): void {
    this.allOn = state;
    this.allOff = !state;
    this.selectedInsuranceOptions.forEach((checkbox) => (checkbox.isChecked = state));
  }
  onCustomOptionChange() {
    const totalChecked = this.selectedInsuranceOptions.filter((cb) => cb.isChecked).length;
    this.allOn = totalChecked === this.selectedInsuranceOptions.length;
    this.allOff = totalChecked === 0;
  }
  updateInsuranceOption() {
    //this.selectedInsuranceOptionsUpdate = this.selectedInsuranceOptions.filter((cb) => cb.isChecked).map((cb) => cb);
    this.selectedInsuranceOptionsUpdate = this.selectedInsuranceOptions.filter((cb) => cb).map((cb) => cb);
    //////console.log ('Selected values:', (this.selectedInsuranceOptionsUpdate));
    this.userService.UpdateInsuranceTypesStatus(this.selectedInsuranceOptionsUpdate).subscribe((updated) => { this.getInsuranceOption(); this.userService.triggerInsuranceNavRefresh(); });
  }
  selectedInsuranceOptions: InsuranceTypesSwitchProps[] = [];
  getInsuranceOption() {
    this.userService.GetInsuranceTypesStatus().subscribe(data => {
      this.selectedInsuranceOptions = data;
      if (this.selectedInsuranceOptions.every(val => val.isChecked === true)) {
        this.allOn = true;
        this.allOff = false;
      } else if (this.selectedInsuranceOptions.every(val => val.isChecked === false)) {
        this.allOn = false;
        this.allOff = true;
      } else {
        this.allOff = false;
        this.allOn = false;
      }

    });
  }

}





